import View from './View';

export { default as getEmptyListPlaceholderStyles } from './styles';
export { default as View } from './View';

export default View;
